import { CommunityId, fullSingleLineAddress } from "@sp-crm/core";
import { AddressDisplay } from "components/contact-display/address-display";
import { PhoneDisplay } from "components/contact-display/phone-display";
import { WebsiteDisplay } from "components/contact-display/website-display";
import { Icon } from "components/icon";
import {
    AdvancedSearchEntityType,
    FindOrCreateCommunityInsightsMutation,
} from "generated/graphql";
import React from "react";

interface CommunityDetailsProps {
    communityId: CommunityId;
    listing: FindOrCreateCommunityInsightsMutation["findOrCreateCommunityInsights"];
}

export const CommunityInsightsDetails = ({
    communityId,
    listing,
}: CommunityDetailsProps) => {
    const address = fullSingleLineAddress(listing);

    return (
        <>
            <div className="flex items-center justify-between mb-4">
                <div className="flex items-center space-x-2">
                    <div className="w-7">
                        <Icon name="57_Community" />
                    </div>
                    <span className="text-lg text-gray-700">Community Details</span>
                </div>
            </div>
            <p className="mb-2">
                <strong>Name:</strong> {listing.name}
            </p>
            {address ? (
                <div className="mb-2">
                    <AddressDisplay value={address} />
                </div>
            ) : null}
            {listing.website ? (
                <div className="mb-2">
                    <WebsiteDisplay value={listing.website} label={null} />
                </div>
            ) : null}
            {listing.phoneNumbers?.map(phoneNumber => (
                <div className="mb-2" key={phoneNumber.number}>
                    <PhoneDisplay
                        value={phoneNumber.number}
                        label={phoneNumber.label || null}
                        entityId={communityId}
                        entityType={AdvancedSearchEntityType.Community}
                    />
                </div>
            ))}
        </>
    );
};
